import Typewriter from "typewriter-effect/dist/core";

export default class VideoTypewriter {
  constructor() {
    console.log("%c👍🏼 Video Typewriter", "color: yellow");

    this.videoTypewriter = document.querySelectorAll(".video-typewriter");
  }
  init() {
    let self = this;

    this.videoTypewriter.forEach((module) => {
      let videoTypewriterEffect = module.querySelector(".video-typewriter__effect");
      let video = module.querySelector('.video-typewriter__video');
      let timeout = 0
      function handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.boundingClientRect.top >= 0) {
              const typewriterArray = videoTypewriterEffect.dataset.typewriterString.split(",");
              const typewriter = new Typewriter(videoTypewriterEffect, {
                loop: false,
                delay: 50,
                cursor: "",
                skipAddStyles: true
              });
              console.log('typewriter', typewriter);
              typewriterArray.forEach((word, index) => {
                 typewriter.typeString(word);
                 timeout += 750;
                if (typewriterArray.length - 1 != index) {
                  typewriter.typeString(",").pauseFor(350).start();
                  timeout += 350;
                } 
              });
            }

            setTimeout(() => {
              video.classList.remove('video-typewriter__video--hidden')
            }, timeout);

            observer.disconnect();
          }
        });
      }

      const observer = new IntersectionObserver(handleIntersection, {
        root: null, // Use the viewport as the root
        threshold: 0.2, // Trigger the callback when 50% of the target is visible
      });

      observer.observe(module);
    });
  }
}
